// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-black {
  color: #212121;
}

.text-white {
  color: #FAFAFA;
}

.color-primary {
  color: #0d67bc;
}

.color-primary-dark {
  color: #172b3d;
}

.color-primary-light {
  color: #4a8bc8;
}

.color-secondary {
  color: #e3f2fc;
}

.color-secondary-dark {
  color: #b1bfc9;
}

.color-secondary-light {
  color: #ffffff;
}

.color-error {
  color: #f44336;
}

.color-warning {
  color: #f49536;
}

.color-accent {
  color: #e3f2fc;
}

.color-success {
  color: #2CBD04;
}

.color-hyperlink {
  color: #0000FF;
}

.background-primary {
  background-color: #0d67bc;
}

.well-color {
  background-color: #bbdff9;
}

.color-carshield-hyperlink {
  color: #1c3344;
}

div {
  display: inline-flex;
  padding: 7px 12px;
  border-radius: 16px;
  align-items: center;
  cursor: default;
  min-height: 32px;
  height: 1px;
}

.chip-warning {
  border: #f44336;
  border-style: solid;
  border-width: 3px;
}`, "",{"version":3,"sources":["webpack://./style/brand/colors.scss","webpack://./src/shared/display-value/plain-chip/plain-chip.component.scss"],"names":[],"mappings":"AAqBA;EACI,cAPS;ACbb;;ADuBA;EACI,cAVS;ACVb;;ADuBA;EACI,cAzBU;ACKd;;ADuBA;EACI,cA3Be;ACOnB;;ADuBA;EACI,cAhCgB;ACYpB;;ADuBA;EACI,cAlCY;ACchB;;ADuBA;EACI,cApCiB;ACgBrB;;ADuBA;EACI,cAzCkB;ACqBtB;;ADuBA;EACI,cAnDS;AC+Bb;;ADuBA;EACI,cAxDW;ACoCf;;ADuBA;EACI,cAnDS;AC+Bb;;ADuBA;EACI,cAjEW;AC6Cf;;ADuBA;EACI,cAxDa;ACoCjB;;ADuBA;EACI,yBArEU;ACiDd;;ADuBA;EACI,yBAjES;AC6Cb;;ADuBA;EACI,cAhEa;AC4CjB;;AA5DA;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA+DJ;;AA5DA;EACI,eDVS;ECWT,mBAAA;EACA,iBAAA;AA+DJ","sourcesContent":["$colorinfo: #424242;\r\n$colorSuccess: #2CBD04;\r\n$colorWarning: #f49536;\r\n$colorError: #f44336;\r\n$colorMuted: #000000;\r\n$Web-primary: #0d67bc;\r\n$Web-primary-light: #4a8bc8;\r\n$Web-primary-dark: #172b3d;\r\n$Web-secondary: #e3f2fc;\r\n$Web-secondary-light: #ffffff;\r\n$Web-secondary-dark: #b1bfc9;\r\n$Web-accent: #e3f2fc;\r\n$danger-dark: #b22222;\r\n$well-color: #bbdff9;\r\n$hyperlink-blue: #0000FF;\r\n$Text-black: #212121;\r\n$Text-white: #FAFAFA;\r\n$Light-gray: #e8e8e8;\r\n$Carshield-dark: #1c3344;\r\n$aas-warn: #c12c2d;  //Copied from Themes.scss\r\n\r\n.text-black {\r\n    color: $Text-black;\r\n}\r\n\r\n.text-white {\r\n    color: $Text-white;\r\n}\r\n\r\n.color-primary {\r\n    color: $Web-primary;\r\n}\r\n\r\n.color-primary-dark {\r\n    color: $Web-primary-dark\r\n}\r\n\r\n.color-primary-light {\r\n    color: $Web-primary-light;\r\n}\r\n\r\n.color-secondary {\r\n    color: $Web-secondary;\r\n}\r\n\r\n.color-secondary-dark {\r\n    color: $Web-secondary-dark;\r\n}\r\n\r\n.color-secondary-light {\r\n    color: $Web-secondary-light;\r\n}\r\n\r\n.color-error {\r\n    color: $colorError;\r\n}\r\n\r\n.color-warning {\r\n    color: $colorWarning;\r\n}\r\n\r\n.color-accent {\r\n    color: $Web-accent;\r\n}\r\n\r\n.color-success {\r\n    color: $colorSuccess;\r\n}\r\n\r\n.color-hyperlink {\r\n    color: $hyperlink-blue;\r\n}\r\n\r\n.background-primary {\r\n    background-color: $Web-primary;\r\n}\r\n\r\n.well-color {\r\n    background-color: $well-color;\r\n}\r\n\r\n.color-carshield-hyperlink {\r\n    color: $Carshield-dark;\r\n}","@import '/style/brand/colors.scss';\r\n\r\ndiv {\r\n    display: inline-flex;\r\n    padding: 7px 12px;\r\n    border-radius: 16px;\r\n    align-items: center;\r\n    cursor: default;\r\n    min-height: 32px;\r\n    height: 1px;\r\n}\r\n\r\n.chip-warning {\r\n    border: $colorError;\r\n    border-style: solid;\r\n    border-width: 3px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
